import { useMemo, useState, useEffect } from 'react';
import { ClinicWidgetSettingResponse } from 'shared/types';
import { WidgetRequestFragment, WidgetVisibility } from 'shared/types/graphql';
import { isClinicOpen } from 'shared/utils/isClinicOpen';

export const useFilterRequests = (
  widgetSetting: ClinicWidgetSettingResponse,
): ClinicWidgetSettingResponse['clinicWidgetRequestTypes'] => {
  const { clinicWidgetRequestTypes, clinic } = widgetSetting;

  const [isClinicOpenNow, setIsClinicOpenNow] = useState(true);

  useEffect(() => {
    // Initial check
    setIsClinicOpenNow(isClinicOpen(clinic[0].clinicOfficeHours));

    // Set up interval to check every 5 minutes
    const intervalId = setInterval(() => {
      setIsClinicOpenNow(isClinicOpen(clinic[0].clinicOfficeHours));
    }, 5 * 60 * 1000);

    // Clean up on unmount
    return (): void => clearInterval(intervalId);
  }, [clinic]);

  return useMemo((): WidgetRequestFragment[] => {
    return clinicWidgetRequestTypes?.filter(
      (request) =>
        request.requestVisibility === WidgetVisibility.Always ||
        (isClinicOpenNow && request.requestVisibility === WidgetVisibility.ClinicOpen) ||
        (!isClinicOpenNow && request.requestVisibility === WidgetVisibility.ClinicClosed),
    );
  }, [clinicWidgetRequestTypes, isClinicOpenNow]);
};
